import { DataTablePaginationButtonProps } from '@/types';
import { Button } from '../ui/button';

function DataTablePaginationButton({
  children,
  srLabel,
  className = 'p-0 size-6',
  ...props
}: DataTablePaginationButtonProps) {
  return (
    <Button className={className} {...props} variant="outline">
      <span className="sr-only">{srLabel}</span>
      {children}
    </Button>
  );
}

export default DataTablePaginationButton;
